<template>
	<a-drawer
		:header-style="{ fontSize: '18px', fontWeight: 600 }"
		placement="right"
		:closable="false"
		width="600px"
		:visible="visible"
		@close="onClose"
		:body-style="{ padding: 0, overflow: 'hidden' }"
	>
		<template slot="title">
			<div class="drawer-header">{{ title || '聊天记录' }}</div>
		</template>

		<div class="chat-container">
			<div class="chat-messages" ref="chatMessages" @scroll="handleScroll">
				<div class="load-more" v-if="hasMoreMessages" @click="loadMoreMessages">
					<span v-if="!loadingMessages">加载更多消息</span>
					<span v-else>加载中...</span>
				</div>

				<div v-for="(item, index) in renderMessageList" :key="index">
					<div class="message-time" v-if="item.showTime">
						<span>{{ item.updatedTime }}</span>
					</div>

					<!-- 自己发送的消息 -->
					<div class="message  message-self" v-if="fromUserInfo.id == item.fromUserId">
						<div class="message-avatar">
							<img :src="item.fromUserAvatarUrl || ''" />
						</div>
						<div class="message-content" v-if="item.type == 'TEXT'">
							<div class="message-bubble">
								<div class="message-text">{{ item.content }}</div>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'IMAGE'">
							<div class="message-image">
								<x-image :src="(item.extra && item.extra.imageUrl) || ''" :width="200" :height="200" />
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VOICE'">
							<div class="message-bubble">
								<voice-message
									:msg-item="{
										content: (item.extra && item.extra.voiceUrl) || '',
										duration: (item.extra && item.extra.duration) || 0,
										isRead: 'Y',
									}"
									:is-self="true"
									@read="handleRead"
								/>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VIDEO'">
							<div class="message-image">
								<video-modal-player
									:video-src="(item.extra && item.extra.videoUrl) || ''"
									:thumbnail="(item.extra && item.extra.coverUrl) || ''"
									video-title="视频"
								/>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'GIFT'">
							<div class="message-image">
								<img :src="(item.extra && item.extra.picUrl) || ''" width="100" height="100" />
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VOLET'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="phone" class="message-type-icon" />
								<div class="message-text">{{ item.extra.text }}</div>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VILET'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="video-camera" class="message-type-icon" />
								<div class="message-text">{{ item.extra.text }}</div>
							</div>
						</div>
						<span class="message-violation" v-if="item.sendStatus == 'FAIL' || item.moderationStatus == 'FAIL'">
							<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
						</span>
					</div>

					<!-- 对方发送的消息 -->
					<div class="message message-other" v-if="toUserInfo.id == item.fromUserId">
						<div class="message-avatar">
							<img :src="item.fromUserAvatarUrl || ''" />
						</div>
						<div class="message-content" v-if="item.type == 'TEXT'">
							<div class="message-bubble">
								<div class="message-text">{{ item.content }}</div>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'IMAGE'">
							<div class="message-image">
								<x-image :src="(item.extra && item.extra.imageUrl) || ''" :width="200" :height="200" />
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VOICE'">
							<div class="message-bubble">
								<voice-message
									:msg-item="{
										content: (item.extra && item.extra.voiceUrl) || '',
										duration: (item.extra && item.extra.duration) || 0,
										isRead: 'Y',
									}"
									:is-self="false"
									@read="handleRead"
								/>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VIDEO'">
							<div class="message-image">
								<video-modal-player
									:video-src="(item.extra && item.extra.videoUrl) || ''"
									:thumbnail="(item.extra && item.extra.coverUrl) || ''"
									video-title="视频"
								/>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'GIFT'">
							<div class="message-image">
								<img :src="(item.extra && item.extra.picUrl) || ''" width="100" height="100" />
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VILET'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="video-camera" class="message-type-icon" />
								<div class="message-text">{{ item.extra.text }}</div>
							</div>
						</div>
						<div class="message-content" v-if="item.type == 'VOLET'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="phone" class="message-type-icon" />
								<div class="message-text">{{ item.extra.text }}</div>
							</div>
						</div>
						<div class="message-violation" v-if="item.sendStatus == 'FAIL' || item.moderationStatus == 'FAIL'">
							<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
						</div>
					</div>

					<div class="system-notice" v-if="item.senderId == 0">
						<span>{{ item.content }}</span>
					</div>
					<div class="system-notice" v-if="item.sendStatus == 'FAIL' || item.moderationStatus == 'FAIL'">
						<span>快牵：倡导文明交友，请勿发送色情低俗、骚扰辱骂等违反平台规则或违法违规等内容，否则您的账号将会受到相应的处罚</span>
					</div>
				</div>
			</div>
		</div>
	</a-drawer>
</template>

<script>
	import { conversationMessageDetail } from '@/api/op/conversation';
	import XImage from '@/components/XImage.vue';
	import VoiceMessage from '@/components/VoiceMessage.vue';
	import VideoModalPlayer from '@/components/VideoModalPlayer.vue';
	import { formatMessageTime, isOverTimeInterval } from '@/utils/dateTime';

	const PAGE_SIZE = 20;

	export default {
		name: 'ConversationMessageDrawer',
		components: {
			XImage,
			VoiceMessage,
			VideoModalPlayer,
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			conversationId: {
				type: [Number, String],
				default: 0,
			},
			fromUserInfo: {
				type: Object,
				default: () => ({ id: null, avatar: '' }),
			},
			toUserInfo: {
				type: Object,
				default: () => ({ id: null, avatar: '' }),
			},
			title: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				renderMessageList: [],
				loadingMessages: false,
				hasMoreMessages: false,
				messagePageIndex: 1,
			};
		},
		watch: {
			visible(val) {
				if (val && this.conversationId) {
					this.messagePageIndex = 1;
					this.hasMoreMessages = false;
					this.renderMessageList = [];
					this.fetchMessages();
				}
			},
			conversationId(val) {
				if (this.visible && val) {
					this.messagePageIndex = 1;
					this.hasMoreMessages = false;
					this.renderMessageList = [];
					this.fetchMessages();
				}
			},
		},
		methods: {
			onClose() {
				this.$emit('update:visible', false);
				this.$emit('close');
			},
			getImageUrl(relativePath) {
				if (!this.ossBaseUrl || !relativePath) return '';
				const base = this.ossBaseUrl.endsWith('/') ? this.ossBaseUrl : this.ossBaseUrl + '/';
				const path = String(relativePath).startsWith('/') ? relativePath.slice(1) : relativePath;
				return base + path;
			},
			parsedAdded(added) {
				try {
					return JSON.parse(added || '{}');
				} catch (e) {
					return {};
				}
			},
			parseExtra(extra) {
				if (extra == null || String(extra).trim() === '') return {};
				try {
					return JSON.parse(extra);
				} catch (e) {
					return {};
				}
			},
			processedMessages(messages) {
				if (!Array.isArray(messages)) return [];
				return messages.map((message, index) => {
					// 不修改原 message；若 extra 已是对象（如加载更多时已有的第一页数据）则直接使用，否则解析
					const extra =
						message.extra != null && typeof message.extra === 'object' && !Array.isArray(message.extra)
							? message.extra
							: this.parseExtra(message.extra);
					const currentTime = message.updateTime;
					const prevTime = index > 0 ? messages[index - 1].updateTime : null;
					const showTime =
						index === 0 || (prevTime && isOverTimeInterval(currentTime, prevTime, 15));
					return {
						...message,
						extra,
						updatedTime: formatMessageTime(currentTime),
						showTime,
					};
				});
			},
			async fetchMessages() {
				if (!this.conversationId) return;
				this.loadingMessages = true;
				try {
					const res = await conversationMessageDetail({
						page: this.messagePageIndex,
						conversationId: this.conversationId,
					});
					const messageList = res.data.messageList;
					this.renderMessageList = this.processedMessages(messageList);

					if (messageList.length >= PAGE_SIZE) {
						this.hasMoreMessages = true;
					}
					this.$nextTick(() => this.scrollToBottom());
				} catch (e) {
					console.error('获取聊天记录失败:', e);
					this.$message.error('获取聊天记录失败');
				} finally {
					this.loadingMessages = false;
				}
			},
			handleRead() {},
			scrollToBottom() {
				this.$nextTick(() => {
					const container = this.$refs.chatMessages;
					if (!container) {
						return;
					}
					container.style.scrollBehavior = 'auto';
					container.scrollTop = container.scrollHeight;
					container.style.scrollBehavior = 'smooth';
					container.scrollTop = container.scrollHeight;
				});
			},
			handleScroll() {
				if (
					this.renderMessageList &&
					this.renderMessageList.length > 0 &&
					this.renderMessageList.length % PAGE_SIZE === 0
				) {
					this.hasMoreMessages = true;
				}
			},
			async loadMoreMessages() {
				if (this.loadingMessages || !this.hasMoreMessages) {
					return;
				}
				this.loadingMessages = true;
				try {
					const container = this.$refs.chatMessages;
					const scrollHeight = container ? container.scrollHeight : 0;

					this.messagePageIndex += 1;
					const res = await conversationMessageDetail({
						page: this.messagePageIndex,
						conversationId: this.conversationId,
					});
					const list = res.data && res.data.messageList ? res.data.messageList : [];
					if (list.length < PAGE_SIZE) this.hasMoreMessages = false;

					this.renderMessageList = this.processedMessages([...list, ...this.renderMessageList]);
					this.$nextTick(() => {
						if (container) {
							container.style.scrollBehavior = 'auto';
							container.scrollTop = container.scrollHeight - scrollHeight;
							container.style.scrollBehavior = '';
						}
					});
				} catch (e) {
					console.error('加载更多消息失败:', e);
				} finally {
					this.loadingMessages = false;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.chat-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		height: calc(100vh - 60px);
	}
	.chat-messages {
		height: 100%;
		overflow-y: auto;
		flex: 1;
		padding: 16px;
		background: #f5f6f7;
		scrollbar-color: #1890ff #bae7ff;
		scrollbar-width: thin;
		position: relative;
	}
	.load-more {
		cursor: pointer;
		text-align: center;
		color: #4078f2;
		padding: 8px 0;
	}
	.message {
		display: flex;
		margin-bottom: 20px;
		align-items: center;
	}
	.message-self {
		flex-direction: row-reverse;
	}
	.message-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
		flex-shrink: 0;
	}
	.message-avatar img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.message-self .message-avatar {
		margin-left: 12px;
	}
	.message-self .message-violation {
		margin-right: 10px;
	}
	.message-other .message-avatar {
		margin-right: 12px;
	}
	.message-other .message-violation {
		margin-left: 10px;
	}
	.message-content {
		max-width: 70%;
	}
	.message-bubble {
		padding: 12px 16px;
		border-radius: 4px;
		position: relative;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	.message-self .message-bubble {
		border-radius: 18px;
		background: #95ec69;
		border-top-right-radius: 4px;
	}
	.message-other .message-bubble {
		background: white;
		color: #1f2329;
		border-radius: 18px;
		border-top-left-radius: 4px;
	}
	.message-text {
		line-height: 1.5;
		word-break: break-word;
	}
	.message-bubble-with-icon {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.message-bubble-with-icon .message-type-icon {
		flex-shrink: 0;
		font-size: 16px;
		color: rgba(0, 0, 0, 0.45);
	}
	.message-self .message-bubble-with-icon .message-type-icon {
		color: rgba(0, 0, 0, 0.5);
	}
	.message-image {
		max-width: 250px;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
	}
	.message-time {
		font-size: 12px;
		color: #86909c;
		margin-top: 4px;
		margin-bottom: 10px;
		text-align: center;
	}
	.system-notice {
		text-align: center;
		margin: 10px 0;
	}
	.system-notice span {
		display: inline-block;
		background-color: #fff8e6;
		color: #d48806;
		padding: 6px 15px;
		border-radius: 15px;
		font-size: 12px;
	}
	.drawer-header {
		font-size: 18px;
		font-weight: 600;
		position: fixed;
		top: 0;
		right: 0;
		width: 600px;
		z-index: 100;
		background: white;
		border-bottom: 1px solid #f0f0f0;
		padding: 16px 24px;
		margin-bottom: 0;
	}
	::v-deep .ant-drawer-wrapper-body {
		overflow-y: hidden;
	}
	::v-deep .ant-drawer-header {
		padding: 27px 24px;
	}
</style>
